import request from '@/utils/request'
import config from '@/config/config'
import axios from 'axios'
import { setInterval, clearInterval, setTimeout } from 'timers'
import { isPhone , isIos} from '@/api/public'
import $ from 'jquery';

const TRS_URL = config.TRS_URL
const NEW_TRS_URL = config['NEW_TRS_URL'];
// const tt = 'cy4fgbil24jucmh8jfr5'

export function getStatus(docId) {
  return request({
    url: `${TRS_URL}/v1/doc/${docId}/status`,
    method: 'get',
  })
}
export function getPreView(userId, docId) {
  return request({
    url: `${TRS_URL}/v1/doc/${docId}/download/info`,
    method: 'post',
    data: {
      'user_id': userId,
    },
  })
}
export function getBacking(userId, docId) {
  return request({
    url:`${NEW_TRS_URL}/v1/doc/${docId}/backing`,
    method: 'post',
    data: {
      'user_id': userId,
    },
  })
}
// export function downFile(userId, doc_id) {
//   return request({
//     url: `${NEW_TRS_URL}/v1/doc/${doc_id}/download/info`,
//     method: 'post',
//     data: {
//       'user_id': userId
//     }
//   })
// }
export function getReadView(userId, docId) {
  return request({
    url: `${TRS_URL}/v1/doc/${docId}/read?download_type=pdf`,
    method: 'get',
  })
}

export function getFree(docId, userId) {
  return request({
    url: `${TRS_URL}/v1/doc/${docId}/free`,
    method: 'post',
    data: {
      'user_id': userId,
    },
  })
}

export function translate(source, type) {
  const transType = changeLangeType(source, type)['trans_type']
  const sourceArr = source.split('\n')
  return request({
    url: `${TRS_URL}/v1/translator`,
    method: 'post',
    data: {
      'source': sourceArr,
      'trans_type': transType || 'en2zh',
      'request_id': 'web_fanyi',
      'detect': true,
      'media': 'text',
      'os_type':'web',
    },
  })
}
export function changeLangeType(source, transType) {
  if (source !== '') {
    let lang = ''
    let trans_type = transType
    let html = ''
    if (transType === 'auto') {
      lang = detectLang(source)
      if (lang === 'en') {
        trans_type = 'en2zh'
        html = '识别到：英语  »  中文'
      } else if (lang === 'jp') {
        html = '识别到：日语  »  中文'
        trans_type = 'ja2zh'
      } else if (lang === 'zh') {
        html = '识别到：中文  »  英语'
        trans_type = 'zh2en'
      } else {
        trans_type = 'zh2en'
      }
    } else {
      trans_type = transType
    }
    return {
      trans_type: trans_type || '',
      trans_html: html ||''
    }
  }
}
export function CollectionPage(userId, url) {
  return request({
    url: `${TRS_URL}/v1/page/favorite`,
    method: 'post',
    data: {
      'article': true,
      'user_id': userId,
      'url': url
    }
  })
}
export function CancelCollection(userId, article_id) {
  return request({
    url: `${TRS_URL}/v1/user/${userId}/unfav`,
    method: 'post',
    data: {
      'user_id': userId,
      'article_id': article_id
    }
  })
}
export function DelDoc(doc_id) {
  return request({
    url: `${TRS_URL}/v1/doc/${doc_id}/delete`,
    method: 'post',
    data: {
      'name': doc_id,
      'in': 'path',
      'description': doc_id,
      'required': true,
      'type': 'integer',
      'format': 'int64'
    }
  })
}
export function postFile(file, ty, id, callback) {
  const formData = new FormData()
  formData.append('trans_type', ty)
  formData.append('file', file)
  formData.append('user_id', id)
  formData.append('os_type', 'web')
  return axios.post(`${TRS_URL}/v1/doc/translate`,
    formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Authorization':'token cy4fgbil24jucmh8jfr5',
      },
      onUploadProgress:(progressEvent) => {
        if (progressEvent.lengthComputable) {
          callback(progressEvent)
        }
      }
  })
}

function detectLang(str) {
  if (typeof str !== 'string') {
    return 'en'
  }
  let lang = 'en'
  let zh_str = str.match(/[\u4e00-\u9fa5]/g) || []
  let zh_per = zh_str.length / str.length
  let jp_reg = /[\u3020-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\u31F0-\u31FF]/g
  let jp_str = str.match(jp_reg) || []
  let jp_per = jp_str.length / str.length

  if (jp_per > 0.03) {
    lang = 'jp'
  } else if (zh_per > 0.10) {
    lang = 'zh'
  }
  return lang
}
export function autoTextarea(elem, extra, maxHeight) {
  extra = extra || 0;
  let isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window,
    isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera'),
    addEvent = function (type, callback) {
      elem.addEventListener ?
        elem.addEventListener(type, callback, false) :
        elem.attachEvent('on' + type, callback);
    },
    getStyle = elem.currentStyle ? function (name) {
      var val = elem.currentStyle[name];
      if (name === 'height' && val.search(/px/i) !== 1) {
        var rect = elem.getBoundingClientRect();
        return rect.bottom - rect.top -
          parseFloat(getStyle('paddingTop')) -
          parseFloat(getStyle('paddingBottom')) + 'px';
      };
      return val;
    } : function (name) {
      return getComputedStyle(elem, null)[name];
    },
    minHeight = parseFloat(getStyle('height'));

  elem.style.resize = 'none';

  let change = function () {
    var scrollTop, height,
      padding = 0,
      style = elem.style;
    if (elem._length === elem.value.length) return;
    elem._length = elem.value.length;

    if (!isFirefox && !isOpera) {
      padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'));
    };
    scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

    elem.style.height = minHeight + 'px';
    if (elem.scrollHeight > minHeight) {
      if (maxHeight && elem.scrollHeight > maxHeight) {
        height = maxHeight - padding;
        style.overflowY = 'auto';
      } else {
        height = elem.scrollHeight - padding;
        style.overflowY = 'hidden';
      };
      style.height = height + extra + 'px';
      scrollTop += parseInt(style.height) - elem.currHeight;
      document.body.scrollTop = scrollTop;
      document.documentElement.scrollTop = scrollTop;
      elem.currHeight = parseInt(style.height);
    };
  };

  addEvent('propertychange', change);
  addEvent('input', change);
  addEvent('focus', change);
  change();
};

export function handleOpen(item){
  // window.open("about:blank","document");
  let _type = '';
  if(item.type == 'doc'){
      _type = '.docx'
  }
  if(item.type == 'pdf'){
      _type = '.pdf'
  }
  if(isPhone()){
    if(isIos()){
      window.location.assign(config.NEW_TRS_URL + '/v1/doc/'+item.doc_id+_type)
    }else{
      window.location.assign('https://a.app.qq.com/o/simple.jsp?pkgname=com.caiyuninterpreter.activity');
    }
  }else{
    window.location.assign(config.NEW_TRS_URL + '/v1/doc/'+item.doc_id+_type)
  }
};




// WEBPACK FOOTER //
// ./src/api/doc.js